import set from 'lodash/set';

export default {
    name: 'smartlookConfig',
    before: [],
    after: [],
    setup: (app) => {
        const smartloookConfig = app.general.getItem('smartlook');
        set(smartloookConfig, 'id', 'd2e411da04dff73bd1e2e7dd4885692e5a08ede1');
        app.general.changeItem('smartlook', smartloookConfig);
    },
};
